import { render, staticRenderFns } from "./OzAvatar.vue?vue&type=template&id=1ba9dad0&"
import script from "./OzAvatar.vue?vue&type=script&lang=ts&"
export * from "./OzAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports